// Thin HTTP client for the Flask backend (backend/src/main.py).
//
// Most of the app reads/writes Firestore directly via the client SDK, so this
// helper only exists for endpoints that are intentionally server-only — like
// the marketing engine, which lives entirely in Flask.
//
// REACT_APP_BACKEND_URL: production URL. Falls back to localhost:5000 (the
// port run-venueboard uses for the backend tab) in dev. If you point at a
// remote backend from local, set REACT_APP_BACKEND_URL in .env.local.
import { auth } from "../firebase";

const BACKEND_URL = (
  process.env.REACT_APP_BACKEND_URL || "http://localhost:5000"
).replace(/\/+$/, "");

export class BackendError extends Error {
  constructor(message, { status, body } = {}) {
    super(message);
    this.name = "BackendError";
    this.status = status;
    this.body = body;
  }
}

async function getAuthHeader() {
  const user = auth.currentUser;
  if (!user) return {};
  const token = await user.getIdToken();
  return { Authorization: `Bearer ${token}` };
}

export async function backendFetch(path, options = {}) {
  const { method = "GET", body, headers = {}, ...rest } = options;
  const url = path.startsWith("http") ? path : `${BACKEND_URL}${path}`;
  const authHeaders = await getAuthHeader();
  const resp = await fetch(url, {
    method,
    headers: {
      "Content-Type": "application/json",
      ...authHeaders,
      ...headers,
    },
    body: body !== undefined ? JSON.stringify(body) : undefined,
    ...rest,
  });
  let parsed = null;
  const text = await resp.text();
  if (text) {
    try {
      parsed = JSON.parse(text);
    } catch {
      parsed = { raw: text };
    }
  }
  if (!resp.ok) {
    const msg = parsed?.error || `Backend request failed (${resp.status})`;
    throw new BackendError(msg, { status: resp.status, body: parsed });
  }
  return parsed;
}
